var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#54B2DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M1 12.785v-.2c0-.599.2-1.298.6-1.797.6-.6 1-1.398 1.2-2.297 0-.7 0-1.299.1-1.998C3.2 3.197 6.4 1 9.5 1h.1c3.1 0 6.3 2.197 6.6 5.393.1.7 0 1.299 0 1.998.2.899.6 1.698 1.2 2.297.4.5.6 1.198.6 1.798v.2c0 .898-.3 1.697-.8 2.396-.8.8-1.8 1.299-2.9 1.399q-4.8.45-9.6 0c-1.1-.1-2.1-.6-2.9-1.399-.5-.599-.8-1.398-.8-2.297M7.1 19.877c.5.599 1.2.998 2 1.098s1.6-.1 2.3-.6c.2-.099.4-.299.5-.498"
  })));
};
export { SvgNotification as ReactComponent };